import { OnboardingTrackingEvents, userTracking } from '@revelio/core';

import { Button, Stack, uiStyles } from './ui';

const Step3A = () => {
  const rerouteUser = () => {
    userTracking.track(OnboardingTrackingEvents.TEST_A_NEWS_BUTTON_CLICK);
    window.location.replace('https://www.reveliolabs.com/news');
  };

  const handleStart = () => {
    rerouteUser();
  };

  return (
    <Stack gap="24px" fullWidth>
      <p className={uiStyles.thanksTitle}>Thanks for signing up!</p>
      <p className={uiStyles.thanksBody}>
        A Revelio Labs team member will reach out shortly to schedule your
        onboarding.
      </p>
      <Button onClick={handleStart}>Latest workforce reports</Button>
    </Stack>
  );
};

export default Step3A;
